export const ActionTypes = {
    SET_DATA: "app/redux/mgt-sensor-data/SET_DATA",
    UPDATE_DATA: "app/redux/mgt-sensor-data/UPDATE_DATA",
    SET_TBL_DATA_LOADING: "app/redux/mgt-sensor-data/SET_TBL_DATA_LOADING",
}